import { render, staticRenderFns } from "./back-to-store-button.vue?vue&type=template&id=332f07b9&lang=pug&"
import script from "./back-to-store-button.vue?vue&type=script&lang=js&"
export * from "./back-to-store-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports